export const isSameAddress = (a1: string, a2: string) => a1.toLowerCase() === a2.toLowerCase();
